module.exports = __webpack_public_path__ + "static/media/252.7de8a9a2.wav";